import DistributionsScheduleSummary from "./DistributionsScheduleSummary";

export default DistributionsScheduleSummary;
